<template>
  <div class="header">
    <nav class="desktopNavbar">
      <router-link to="/"><img class="logo" src="../assets/logo.svg"></router-link>
      <ul>
        <li>
          <router-link to="/">Our Brand</router-link>
        </li>
        <li @mouseover="subMenu = true" @mouseleave="subMenu = false">
          <span @click="subMenu = false">
            <router-link to="/identity">Visual Identity</router-link>
          </span>
          <ul v-if="subMenu === true" class="subMenu">
            <li @click="subMenu = false">
              <router-link to="/identity/logotype">Logo</router-link>
            </li>
            <li @click="subMenu = false">
              <router-link to="/identity/pixel-head">Pixel Head</router-link>
            </li>
            <li @click="subMenu = false">
              <router-link to="/identity/typography">Fonts</router-link>
            </li>
            <li @click="subMenu = false">
              <router-link to="/identity/colors">Colors</router-link>
            </li>
            <li @click="subMenu = false">
              <router-link to="/identity/templates">Templates</router-link>
            </li>
            <li @click="subMenu = false">
              <router-link to="/identity/images">Images</router-link>
            </li>
            <li @click="subMenu = false">
              <router-link to="/identity/videos">Videos</router-link>
            </li>
            <li @click="subMenu = false">
              <router-link to="/identity/icons">Icons</router-link>
            </li>
          </ul>
        </li>
        <!-- <li>
          <router-link to="/inspiration">Inspiration</router-link>
        </li>
        Den här sidan kommer tillbaka när design finns så släng inte själva filen (2022-10-25) -->
        <li>
          <router-link to="/information">Sales Materials</router-link>
        </li>
        <li>
          <router-link to="/form">Request Form</router-link>
        </li>
      </ul>
    </nav>
    <nav class="mobileNavbar">
      <router-link to="/"><img class="logo" src="../assets/logo.svg"></router-link>
      <div class="burgerMenu" @click="mobileMenu = !mobileMenu">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <ul v-if="mobileMenu === true" class="mobileMenu">
        <li>
          <router-link to="/">
            <a @click="mobileMenu = !mobileMenu">Our Brand</a>
          </router-link>
        </li>
        <li>
          <router-link to="/identity">
            <a @click="mobileMenu = !mobileMenu">Visual Identity</a>
          </router-link>
        </li>
        <!-- <li>
          <router-link to="/inspiration">
            <a @click="mobileMenu = !mobileMenu">Inspiration</a>
          </router-link>
        </li> -->
        <li>
          <router-link to="/information">
            <a @click="mobileMenu = !mobileMenu">Sales Materials</a>
          </router-link>
        </li>
        <li>
          <router-link to="/form">
            <a @click="mobileMenu = !mobileMenu">Request Form</a>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      mobileMenu: false,
      subMenu: false,
    };
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  $headerMargin = 4rem
  $menuItemsMargin = 4rem
  .header
    position: sticky
    top: 0
    left: 0
    right: 0
    background-color: $white
    box-shadow: 0 -6px 10px 5px rgba(0,0,0,0.5)
    z-index: 100
  .logo
    width: 7.5rem
    margin-bottom: -0.5rem

  .desktopNavbar
    display: flex
    justify-content: space-between
    align-items: center
    height: 9rem
    padding: 0 $headerMargin

    ul
      display: flex

      li
        position: relative
        margin-left: $menuItemsMargin
        font-size: 2.4rem
        font-weight: 700
        color: $primary-color
        text-decoration: none
        list-style-type: none;
        border-bottom: 2px solid transparent

        &:hover
          border-bottom: 2px solid $primary-color

        .router-link-exact-active
          border-bottom: 2px solid $primary-color

        ul
          display: flex
          flex-direction: column
          position: absolute
          top: 3.3rem
          color: $primary-color
          background-color: $white

          li
            margin-left: - $menuItemsMargin
            list-style-type: none

            .router-link-exact-active
              border-bottom: none

            &:first-of-type
              padding-top: 0.5rem

            a
              display: block
              padding: 1.2rem 3rem 1.2rem 2rem
              font-size: 2.2rem
              font-weight: 400
              cursor: pointer

            &:hover
              background-color: $secondary-color
              border-bottom: 2px solid transparent

    @media only screen and (max-width: 1000px)
      display: none

  .mobileNavbar
    display: flex
    justify-content: space-between
    align-items: center
    height: 9rem
    padding: 0 $headerMargin

    .burgerMenu
      display: inline-block
      cursor: pointer

      div
        height: 3px
        width: 28px
        margin: 5px 0
        background-color: $primary-color

    .mobileMenu
      display: flex
      flex-direction: column
      position: absolute
      top: 7rem
      right: 0
      bottom: 0
      color: $primary-color
      background-color: $white
      text-align: right
      width: 100%
      height: 100vh

      li
        padding: 0.6rem $headerMargin 0.6rem 0
        list-style-type: none

        &:first-of-type
          padding-top: 0.5rem

        a
          font-size: 2.4rem
          font-weight: 500

        &:hover
          text-decoration: underline

    @media only screen and (min-width: 1000px)
      display: none

</style>
